<template>
  <div>
    <Header  path='/contactUs'></Header>
    <div class="page-contactUs ui-flex ui-flex-justify-center">

      <div class="ele-wrap ui-flex ">
        <div class="contactUs-part1 ui-flex"></div>
        <div class="contactUs-part2">
          <div class="part2-item part2-title">联系我们</div>
          <div class="part2-item part2-phone">023-47773287</div>
          <div class="part2-item part2-office">邮政编码：400060</div>
          <div class="part2-item part2-address">联系地址：重庆市江津区双福新区津马大道7号</div>
        </div>
      </div>


    </div>
    <Footer></Footer>
  </div>


</template>
<script>
   import Header from '@/components/Header/index.vue'
  import Footer from '@/components/Footer/index.vue'
  import router from '@/router'
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {


      }
    },

  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>